import React from "react";
import BusinessEntityShowContent from "../shared/components/BusinessEntityShowContent";
import Background from "../../shared/components/ui/Background";
import sample1Logo from "./images/sample1_logo.jpeg";

const demoBusinessEntity = {
  code: "01JMXGSX69BMD0RVYY37D0SB87",
  business_type: '法人',
  use_case: "client",
  is_own: false,
  name: "A-Loop設計事務所",
  name_kana: "",
  branch_name: "",
  introduction:
    "大阪府に拠点を構える建築意匠設計の専門事務所です。\n\n1981年の設立以来、「人と空間の調和」を理念に掲げ、機能性と美しさを兼ね備えた建築デザインを提供してきました。\n住宅（戸建・集合住宅）や商業施設、オフィスビル、公共施設、ホテルなど、多岐にわたるプロジェクトを手がけています。\n\n都市の発展とともに成長し、持続可能な建築デザインを追求しながら、地域社会に貢献する建築を創造してきました。また、環境配慮型建築やリノベーション、都市再生プロジェクトにも積極的に関与し、革新的なデザインと先進技術を取り入れることで、より良い空間づくりに取り組んでいます。デザインコンサルティングやプロジェクト監修にも力を入れ、多くのクライアントと長期的なパートナーシップを築いています。",
  number_of_employees: 5,
  main_client:
    "エーループ都市開発株式会社\nエーループホテルグループ\nエーループ文化施設管理機構",
  postal_code: "5420062",
  address1: "大阪市中央区上本町西",
  address2: "1丁目1-5",
  address3: "エーループビル10階",
  establishment_year_month: "1981/10",
  capital_ten_thousand_yen: 2500,
  president_name: "青瀬 花子",
  facebook_url: "https://www.facebook.com",
  instagram_url: "https://www.instagram.com",
  note_url: "https://note.com",
  pinterest_url: "https://www.pinterest.jp",
  threads_url: "https://www.threads.net",
  tiktok_url: "https://www.tiktok.com",
  x_url: "https://twitter.com",
  youtube_url: "https://www.youtube.com",
  website_url: "https://aloop.jp/",
  prefecture: { id: 27, name: "大阪府" },
  industry: { id: 1, name: "意匠設計事務所" },
  logo_image_url: sample1Logo,
  used_architectural_software_categories: [
    {
      category: "2DCAD",
      softwares: [
        { id: 1, name: "AutoCAD" },
        { id: 2, name: "DRA-CAD" },
        { id: 3, name: "Jw_cad" },
        { id: 4, name: "その他" },
      ],
    },
    {
      category: "3DCAD・モデリング",
      softwares: [
        { id: 5, name: "3dsMAX" },
        { id: 6, name: "ARCHITREND ZERO" },
        { id: 7, name: "Blender" },
        { id: 8, name: "Cinema4D" },
        { id: 9, name: "Rhinoceros 3D" },
        { id: 10, name: "Shade3D" },
        { id: 11, name: "SketchUp" },
        { id: 12, name: "Twinmotion" },
        { id: 13, name: "Vectorworks" },
        { id: 14, name: "その他" },
      ],
    },
    {
      category: "BIM",
      softwares: [
        { id: 15, name: "Archicad" },
        { id: 16, name: "Autodesk Revit" },
        { id: 17, name: "GLOOBE" },
        { id: 18, name: "Tekla Structures" },
        { id: 19, name: "VectorWorks architect" },
        { id: 20, name: "その他" },
      ],
    },
    {
      category: "一貫構造計算",
      softwares: [
        { id: 21, name: "Super Build／SS7（SS3）" },
        { id: 22, name: "ASCAL" },
        { id: 23, name: "BUILD.一貫V（IV＋）" },
        { id: 24, name: "Building Editor" },
        { id: 25, name: "BUS-6、NBUS7" },
      ],
    },
    { category: "木造構造計算", softwares: [{ id: 26, name: "KIZUKURI" }] },
  ],
  client_info: {
    desired_business_service_note:
      "ランドスケープデザイン\n\n大規模公園や商業施設の外構計画\nグリーンインフラを活用した環境配慮型デザイン\n屋上緑化・壁面緑化の設計\n\n施工図作成・BIMモデリング\n\n建築施工に必要な詳細図の作成\nBIMを活用した3Dモデル設計・データ管理\n施工時のコラボレーション支援（BIM活用）",
    desired_industries: [
      { id: 1, name: "意匠設計事務所" },
      { id: 2, name: "構造設計事務所" },
      { id: 3, name: "設備設計事務所" },
      { id: 4, name: "組織設計事務所" },
      { id: 5, name: "総合建設業（ゼネコン）" },
      { id: 6, name: "ハウスメーカー" },
      { id: 7, name: "工務店" },
    ],
    desired_business_fields: [
      { id: 1, name: "意匠設計" },
      { id: 10, name: "BIMデータ作成" },
      { id: 14, name: "ランドスケープデザイン" },
      { id: 2, name: "構造設計" },
    ],
  },
  contractor_info: null,
};

const SamplesShow1 = () => {
  return (
    <Background color="brand.50">
      <BusinessEntityShowContent
        businessEntity={demoBusinessEntity}
        currentUser={undefined}
        preview={false}
        disableBackLink
      />
    </Background>
  );
};

export default SamplesShow1;
